import React, { useContext, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Login, PreviewBar, Resume, Signup, UserForm } from "..";
import { Button, Heading, Modal, Navbar, UpgradeModal } from "../../components";
import {
  ResumeContext,
  ResumeContextProvider,
} from "../../contexts/resumeContext";
import styles from "./main.module.css";
import { db } from "../../firebase";
import {
  ChevronRight,
  StarFull,
  Trophy,
  Wait,
} from "../../components/Icons/Icons";
import { UserContext } from "../../contexts/userContext";
import { COLOR_OPTIONS } from "../../utils/constants";

const isMobile = window?.innerWidth < 600

function Main() {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const { user } = useContext(UserContext);
  const {
    setResumeInfo,
    resumeInfo,
    setDocumentDataRef,
    setActiveDesign,
    setActiveColor,
    setActiveFontSize,
  } = useContext(ResumeContext);

  const activeSection = searchParams.get("section");
  const auth = searchParams.get("auth");

  const [showModal, toggleModal] = useState(false);
  const [showUpgradeModal, toggleUpgradeModal] = useState(false);

  useEffect(() => {
    if (user) {
      getDocData();
      setSearchParams({ section: "personal" });
    } else {
      setSearchParams({ section: "personal", auth: "register" });
    }
  }, [user]);

  const getDocData = async () => {
    toggleModal(true);
    const docRef = doc(db, "documents", params.docId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let docData = docSnap.data();
      const docDataRef = doc(db, "documentData", docData.docDataRef);
      setActiveDesign(docData.design);
      setActiveColor(docData.color || COLOR_OPTIONS?.[docData.design]?.[0]);
      setActiveFontSize(docData.fontSize || "12px");
      if (!docData.user) {
        await updateDocUser(docRef);
        await updateDocUser(docDataRef);
      }
      const docDataSnap = await getDoc(docDataRef);
      if (docDataSnap.exists()) {
        setDocumentDataRef(docData.docDataRef);
        setResumeInfo(docDataSnap.data());
      }
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
    toggleModal(false);
  };

  const updateDocUser = async (docRef) => {
    await setDoc(docRef, { user: user?.uid }, { merge: true });
  };

  return (
    <>
      <Navbar />
      <div className={styles.main} section={activeSection}>
        <div
          className={styles.col}
          style={
            activeSection == "preview" ? { width: "35%" } : { width: "50%" }
          }
        >
          {activeSection !== "preview" ? (
            <UserForm />
          ) : (
            !isMobile && <PreviewBar toggleUpgradeModal={toggleUpgradeModal} />
          )}
        </div>
        <div
          className={`${styles.col} ${
            activeSection == "preview" ? styles.preview : ""
          }`}
          style={{ background: "lightgray" }}
        >
          <Resume toggleUpgradeModal={toggleUpgradeModal} />
        </div>
      </div>
      <Modal active={showModal}>
        <div className={styles.modal}>
          <div className={styles.svg}>
            <Wait />
          </div>
          <p className={styles.modalText}>
            Almost there! <br />
            Fasten your seatbelt...
          </p>
        </div>
      </Modal>
      <Modal active={!user} className={styles.authModal}>
        {auth == "register" ? <Signup modal /> : <Login modal />}
      </Modal>
      <UpgradeModal
        active={showUpgradeModal}
        onClose={() => toggleUpgradeModal(false)}
      />
    </>
  );
}

export default Main;
